import { render, staticRenderFns } from "./change-election-dialog.vue?vue&type=template&id=65e6023c&scoped=true"
import script from "./change-election-dialog.vue?vue&type=script&lang=js"
export * from "./change-election-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e6023c",
  null
  
)

export default component.exports